module.exports = __webpack_public_path__ + "static/media/user-crown.05fb9154.svg";